var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('CAssociationsInputsHeader',{attrs:{"message":_vm.message}}),_c('CSearchResult',{on:{"articleToggled":_vm.toggleAddable}}),_c('CCartAssociations',{attrs:{"discountables":_vm.discountables},on:{"removeDiscountable":_vm.removeDiscountable}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }